import { useTranslation } from 'next-i18next';

import { Box } from '@chakra-ui/react';

import { GridWrapper } from '@nocowanie/common-ui/components/atoms/grid-wrapper';
import { SeoLinks } from '@nocowanie/common-ui/components/molecules/seo-links';

import { SectionNameEnum } from '@app/enums';
import { PopularTravelDestinationsModel } from '@app/models/elastic-search';
import { homepageSelectors } from '@app/state/slices/homepage/homepage.selectors';
import { useAppSelector } from '@app/state/state';

import { SeoLinksHomepageProps } from './seo-links-homepage.props';

export const SeoLinksHomepage = ({ ...props }: SeoLinksHomepageProps) => {
    const popularTravelDestinations = useAppSelector(
        homepageSelectors.selectSectionData<PopularTravelDestinationsModel>(
            SectionNameEnum.PopularTravelDestinations,
        ),
    );
    const { t } = useTranslation('home', {
        keyPrefix: 'seoLinks',
    });

    if (!popularTravelDestinations?.length) {
        return;
    }
    return (
        <Box bg={'gray.25'} data-testid={'seo-links-wrapper'} {...props}>
            <GridWrapper gridTemplateColumns={{ base: '1fr' }}>
                <SeoLinks title={t('title')} linkSections={popularTravelDestinations} />
            </GridWrapper>
        </Box>
    );
};
